import { Colors } from "@chakra-ui/react";

const colors: Colors = {
  black: "#16161D",
  lemon: "#C7FFAC",
  lightGrey: "#F5F5F5",
  darkGray: "#363740",
  slack: "#521753",
  xero: "#1AB4D7",
  purpleHeart: {
    400: "#854BDB",
    500: "#6A30D0",
    600: "#481298"
  },
  blackAlpha: {
    10: "#FCFCFD",
    20: "#FAFAFA",
    30: "#F7F6F2"
  },
  primary: {
    10: "rgba(223, 55, 99, 0.06)",
    50: "#ffe5ef",
    100: "#f9bbcc",
    200: "#ef90a9",
    300: "#e76487",
    400: "#df3965",
    500: "#df3763",
    600: "#b91746",
    700: "#700f2a",
    800: "#450618",
    900: "#1e0007"
  },
  secondary: {
    30: "rgba(106, 48, 208, 0.12)",
    40: "rgba(106, 48, 208, 0.25)",
    50: "#a58af5",
    100: "#875bf0",
    200: "#6b2deb",
    300: "#5814d1",
    400: "#4c297b",
    500: "#380a75",
    600: "#310967",
    700: "#1d0548",
    800: "#1d0548",
    900: "#09001c"
  }
};

export default colors;
